import { FieldLabel } from 'components/core/dynamic-form/fields/FieldLabel'
import { RenderFieldProps, UnknownField } from 'components/core/dynamic-form/fields/RenderField'
import { RenderMultiPickerField } from 'components/core/dynamic-form/fields/string-slice/RenderMultiPickerField'
import { isStringSliceFieldLocked } from 'components/core/dynamic-form/providerConfigUtils'
import { C1LabeledChipsInput } from 'components/core/RHKFormComponents/C1LabeledChipsInput'
import { FC } from 'react'

export const RenderStringSliceField: FC<RenderFieldProps> = ({ field, cField, errors, disabled }) => {
    if (field.type.oneofKind !== 'stringSliceField') return <UnknownField field={field} />

    const stringSliceField = field.type.stringSliceField
    const lockDefaultValues = isStringSliceFieldLocked(field)

    switch (stringSliceField.view.oneofKind) {
        case 'chipsField':
            return <C1LabeledChipsInput
                label={<FieldLabel name={field.displayName} required={field.required} />}
                name={field.name}
                placeholder={stringSliceField.placeholder || ''}
                error={!!errors[field.name]}
                helperText={(errors[field.name]?.message as string) || field.description}
                value={cField.value || []}
                onChange={cField.onChange}
                onBlur={cField.onBlur}
                disabled={disabled}
                lockedValues={lockDefaultValues ? stringSliceField.defaultValues : undefined}
            />
        case 'pickerField':
            return <RenderMultiPickerField
                field={field}
                cField={cField}
                errors={errors}
                disabled={disabled}
                lockedValues={lockDefaultValues ? stringSliceField.defaultValues : undefined}
                pickerField={stringSliceField.view.pickerField}
            />
        default:
            return <UnknownField field={field} />
    }
}
